define(function (require) {

    window.lpTag = window.lpTag || {};

    var TabsManagerViewController = require('web-agent-viewControllers/TabsManagerViewController');
    var MainWidgetsManagerViewController = require('web-agent-viewControllers/MainWidgetsManagerViewController');
    var WidgetsManagerViewController = require('web-agent-framework/WidgetsManagerViewController');
    var EngagementViewController = require('web-agent-viewControllers/EngagementViewController');
    var ViewController = require('web-agent-framework/ViewController');

    var EngagementAreaViewController = ViewController.extend({
        ControllerName: "EngagementAreaViewController",

        events : function () {
            var self = this;
            this.bindModel({modelPath : "agent.chatsResumedCount", callback : bindParticipants });

            this.bindModel({modelPath : "agent.status", callback : this.statusChanged});
            this.bindViewEvent({selector : window, DOMEvent : "resize", callback : this.render});

            this.viewEventsHandler.bindEvent({appName : TabsManagerViewController.applicationType, UIEvent : this.eventType.VISITOR_FOCUSED, callback : this.hideWidgetsArea});
            this.viewEventsHandler.bindEvent({appName : TabsManagerViewController.applicationType, UIEvent : this.eventType.VISITOR_BLURRED, callback : this.updateWidgetsAreaVisibility});

            function bindParticipants(){
                self.unbindModel({modelPath : "agent.chatsResumedCount", callback : bindParticipants });
                self.bindModel({modelPath : "participants.myEngagements", callback : self.handleCreateNewEngagementWidget});
                self.bindModel({modelPath : "participants.simulatedEngagements", callback : self.handleCreateNewEngagementWidget});
            }
        },
        LPViewMap: {
            engagementsArea: ".lpview_engagements_area",
            engagementWidget: ".lpview_engagement_widget"
        },

        LPCSSValues: {
            widgetArea: {
                paddingLeft: 4,
                paddingRight: 14,
                generalPadding: 20
            }
        },

        initialize: function (constructorData) {
            this.engagementWidgets = {};
            this.engagementsArea = this.getFirstElement(this.LPViewMap.engagementsArea);
        },

        // events: function () {
        //     this.bindModel({modelPath : "participants.myEngagements", callback : this.handleCreateNewEngagementWidget});
        //     this.bindModel({modelPath : "participants.simulatedEngagements", callback : this.handleCreateNewEngagementWidget});
        //     this.bindModel({modelPath : "agent.status", callback : this.statusChanged});
        //     this.bindViewEvent({selector : window, DOMEvent : "resize", callback : this.render});

        //     this.viewEventsHandler.bindEvent({appName : TabsManagerViewController.applicationType, UIEvent : this.eventType.VISITOR_FOCUSED, callback : this.hideWidgetsArea});
        //     this.viewEventsHandler.bindEvent({appName : TabsManagerViewController.applicationType, UIEvent : this.eventType.VISITOR_BLURRED, callback : this.updateWidgetsAreaVisibility});
        // },

        render: function () {
            if (this.widgetsArea) {
                var widgetsAreaWidth = this.view.clientWidth;//parseInt(this.getComputedStyle(this.view, "width"), 10) || 0;
                var width = 0;
                var left = 0;
                if (this.focusedVisitorId) { // widgets area of an engagement
                    var engagementWidget = this.engagementWidgets[this.focusedVisitorId];
                    if (engagementWidget) {
                        width = engagementWidget.view.firstChild.clientWidth;//parseInt(this.getComputedStyle(engagementWidget.view.firstChild, "width"), 10);
                        left = parseInt(this.getComputedStyle(engagementWidget.view.firstChild, "left"), 10);
                        left += this.LPCSSValues.widgetArea.paddingLeft + width;
                        widgetsAreaWidth -= (left + this.LPCSSValues.widgetArea.paddingRight);
                    }
                } else { // widgets area of visitor list
                    left = 500;
                    widgetsAreaWidth -= (left + this.LPCSSValues.widgetArea.generalPadding);
                }
                this.widgetsArea.view.firstChild.style.width = widgetsAreaWidth + "px";
                this.widgetsArea.view.firstChild.style.left = left + "px";
            }
        }
    });

    EngagementAreaViewController.prototype.updateWidgetsAreaVisibility = function (data) {
        var that = this;

        if (data && data.removedValue) { // Ignoring "Remove key" on visitor feed list
            return;
        }

        setTimeout(function () {
            var counter = 0;


            for (var prop in that.engagementWidgets) {
                if (that.engagementWidgets.hasOwnProperty(prop)) {
                    counter++;
                }
            }

            that.render.call(that);
            var isSimulated = lpTag.WebAgent.engagementSimulator.isSimulatedEngagementVisible();
            // This is a temp solution for us to notify the FW in which page the WebAgent is present.
            var focusedName = 'EngagementArea';
            if (isSimulated) {
                focusedName = 'SimulatedEngagement';
            }
            LE.context.set("LEWebAgent.page", focusedName);

            if (counter > 0) {
                // To prevent an issue when toggling between visitors list to an engagement (after resizing the browser window)
                // [Adi 23/May/2013]
                that.widgetsArea.lpShow();
                // Notifying the LE FW that the widgets area is visible
                if (isSimulated) {
                    setTimeout(function () {
                        LE.vent.trigger(LE.mediaCodes.webAgent.vent.widgetsAreaVisible);
                    }, 200);
                }

            } else {
                that.widgetsArea.lpHide();
            }
        }, 50);
    };

    EngagementAreaViewController.prototype.hideWidgetsArea = function () {
        if (this.widgetsArea) {
            this.widgetsArea.lpHide();
        }
    };

    EngagementAreaViewController.prototype.statusChanged = function (data) {
        if (data.newValue === 'loggedIn' && typeof data.newValue !== 'undefined') {
            if (!this.widgetsArea) {
                this.widgetsArea = new MainWidgetsManagerViewController({
                    modelController: this.modelController,
                    templateFile: "LP_right_pane.html"
                });

                WidgetsManagerViewController.manager = this.widgetsArea; // TODO: Check if required to set the manager for global references.

                this.addViewController({viewController : this.widgetsArea, hidden : true});
            }
        } else {
            this.widgetsArea = null;
            this.engagementWidgets = {};
        }
    };

    EngagementAreaViewController.prototype.handleCreateNewEngagementWidget = function (data) {
        for (var visitorId in data.newValue) {
            if (data.newValue.hasOwnProperty(visitorId)) {
                this.handleCreateSingleEngagement(visitorId, data.newValue[visitorId]);
            }
        }
    };

    EngagementAreaViewController.prototype.handleCreateSingleEngagement = function (visitorId, visitorData) {
        if (!this.engagementWidgets[visitorId] || this.engagementWidgets[visitorId].disposed) {
            this.engagementWidgets[visitorId] = new EngagementViewController({
                modelController : this.modelController,
                visitorId : visitorId,
                visitorSerialNumber : visitorData.participantInfo.visitorSerialNumber,
                className : "lpview_engagement_widget",
                templateFile : 'LP_engagement_widget.html',
                hidden: true,
                chatsRootModelPath : "chats"
            });
            var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
            this.bindModel({modelPath : participantPath + ".chats", callback : this.handleNewChatAccepted});
            this.viewEventsHandler.bindEvent({appName : visitorId, UIEvent : this.eventType.VISITOR_FOCUSED, callback : this.visitorFocused});
            this.viewEventsHandler.bindEvent({appName : visitorId, UIEvent : this.eventType.VISITOR_DISPOSED, callback : this.visitorDisposed});
        }
    };

    EngagementAreaViewController.prototype.handleNewChatAccepted = function (data) {
        var visitorId = data.key.split('.')[2];
        // since this call will happen every time that we have a split session we make sure that we add the viewController only once
        if (!this.engagementWidgets[visitorId].alreadyAdded) {
            this.addViewController({viewController : this.engagementWidgets[visitorId], target : this.LPViewMap.engagementsArea, beforeView : this.getFirstElement(this.LPViewMap.engagementWidget, this.engagementsArea), fadeIn : true});
            this.engagementWidgets[visitorId].alreadyAdded = true;
        }

        var that = this;
        setTimeout(function() {
            that.updateWidgetsAreaVisibility();
        }, 0);
    };

    EngagementAreaViewController.prototype.visitorFocused = function (data) {
        if (data.newValue) {
            this.focusedVisitorId = data.newValue.appName;
        }
    };

    EngagementAreaViewController.prototype.resetVisitorWidgetsScroller = function (visitorId) {
        for (var i = 0; i < this.widgetsArea.widgetsDataArray.length; i++) {
            this.widgetsArea.widgetsDataArray[i].scrollPosition = this.widgetsArea.widgetsDataArray[i].scrollPosition || {};
            this.widgetsArea.widgetsDataArray[i].scrollPosition[visitorId] = 0;
        }
    };

    EngagementAreaViewController.prototype.visitorDisposed = function (data) {
        if (data.newValue) {
            var visitorId = data.newValue.eventData.visitorId;
            this.resetVisitorWidgetsScroller(visitorId);
            // Do not dispose, the widget should dispose itself.
            this.engagementWidgets[visitorId] = undefined;
            delete this.engagementWidgets[visitorId];
            var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
            this.unbindModel({modelPath : participantPath + ".chats", callback : this.handleNewChatAccepted});
            this.viewEventsHandler.unbindEvent({appName: visitorId});
        }

        if (this.widgetsArea.visible) {
            this.updateWidgetsAreaVisibility();
        }
    };

    return EngagementAreaViewController;

});
